import { reactive } from "vue";
import { supervisorApi } from "@/api/supervisor";
import { defineStore } from "pinia";
import { replace } from "@/utils/vue";

export const useSupervisorStore = defineStore('supervisor', () => {

  const reports = reactive<any[]>([])

  const requestReports = async () => {
    const resp = await supervisorApi.getAllReports()
    replace(reports, resp)
  }
  
  return {
    reports,
    requestReports
  }
})